export const BRAND = {
  name: "Celebrity Bouncers",
  tagline: "Premium Event Security & VIP Support",
  region: "Andhra Pradesh & Telangana",
  phonePrimary: "+91 90529 10159",
  phonePrimaryHref: "tel:+919052910159",
  phoneSecondary: "+91 99850 11152",
  phoneSecondaryHref: "tel:+919985011152",
  email: "celebritybouncers99@gmail.com",
  address: "Sri Akshita Oaks, Currency Nagar, Vijayawada, Andhra Pradesh – 520008",
  whatsapp:
    "https://wa.me/919052910159?text=Hello%20Celebrity%20Bouncers%2C%20I%20need%20security%20support%20for%20an%20event.%20Event%20Date%3A%20%20City%3A%20%20Event%20Type%3A",
  directions:
    "https://www.google.com/maps/search/?api=1&query=Sri+Akshita+Oaks%2C+Currency+Nagar%2C+Vijayawada%2C+Andhra+Pradesh+520008",
};

const img = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
  hero: [
    { src: img("1519167758481-83f550bb49b3", 1920), alt: "Elegant Indian wedding venue illuminated for an evening celebration" },
    { src: img("1547786106-2588961a32f6", 1920), alt: "Red carpet entrance with stanchions at a premium event" },
    { src: img("1470229722913-7c0e2dbbafd3", 1920), alt: "Concert stage lights over an organised audience" },
    { src: img("1566073771259-6a8506099945", 1920), alt: "Luxury hotel entrance driveway at dusk" },
  ],
  hospitality: img("1414235077428-338989a2e8c0", 1200),
  hospitalityTwo: img("1551882547-ff40c63fe5fa", 1200),
  team: img("1560250097-0b93528c311a", 1200),
  finalCta: img("1547786106-2588961a32f6", 1920),
  about: img("1556742049-0cfed4f6a45d", 1200),
  venue: img("1511795409834-ef04bbd61622", 1400),
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Events", to: "/events" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "About", to: "/about" },
  { label: "Locations", to: "/locations" },
  { label: "Contact", to: "/contact" },
];

export const MARQUEE_ITEMS = [
  "Andhra Pradesh & Telangana Coverage",
  "Guest-Conscious Security",
  "Customised Team Deployment",
  "24/7 Enquiry Assistance",
  "One-Point Event Coordination",
  "Weddings · Concerts · Corporate Launches",
  "VIP Movement Support",
  "Presence · Precision · Privacy · Hospitality",
];

export const TRUST_ITEMS = [
  { icon: "map", text: "AP & Telangana Event Coverage" },
  { icon: "layers", text: "Customised Team Deployment" },
  { icon: "heart", text: "Guest-Conscious Security" },
  { icon: "clock", text: "24/7 Enquiry Assistance" },
  { icon: "user", text: "One-Point Event Coordination" },
];

export const EVENT_TYPES = [
  "Wedding / Reception",
  "Celebrity Appearance",
  "Corporate Event / Brand Launch",
  "Concert / Live Event",
  "Showroom / Mall Opening",
  "Political / Public Gathering",
  "Private VIP Celebration",
  "Other",
];

export const GUEST_COUNTS = ["Under 100", "100 – 300", "300 – 700", "700 – 1500", "1500+"];

export const TEAM_SIZES = ["Not sure yet", "2 – 4 personnel", "5 – 8 personnel", "9 – 15 personnel", "15+ personnel"];

export const SERVICES = [
  {
    id: "vip-movement",
    icon: "star",
    title: "Celebrity & VIP Movement Support",
    short: "Composed arrival-to-departure movement support for artists, public figures and distinguished guests.",
    suitable: ["Film promotions", "Award evenings", "Store & showroom appearances", "Private visits"],
    scope: "Arrival and departure coordination, holding-area readiness, route awareness within the venue, and quiet liaison with organisers, venue staff and travel teams.",
    planning: ["Profile and itinerary review", "Venue walkthrough", "Movement sequencing", "On-day briefing and positioning"],
    customisation: "Team strength, dress code, vehicle coordination and language preference are tailored to the occasion.",
  },
  {
    id: "event-bouncers",
    icon: "shield",
    title: "Premium Event Bouncers",
    short: "Well-groomed, disciplined event personnel who protect the atmosphere as much as the venue.",
    suitable: ["Private parties", "Club & lounge events", "Ticketed gatherings", "Festive celebrations"],
    scope: "Entry screening support, inside-venue positioning, stage-front presence and calm crowd interaction throughout the event.",
    planning: ["Guest profile discussion", "Venue layout review", "Positioning plan", "Shift and relief scheduling"],
    customisation: "Uniform preference, male or mixed teams, visible or discreet positioning.",
  },
  {
    id: "wedding-security",
    icon: "heart",
    title: "Wedding Security & Guest Management",
    short: "Gracious guest assistance and quiet protection for weddings, receptions and family functions.",
    suitable: ["Weddings", "Receptions", "Sangeet & pre-wedding events", "Destination functions"],
    scope: "Guest reception support, gift and stage area attention, family movement assistance, vendor entry control and parking coordination.",
    planning: ["Family consultation", "Venue and entry-point review", "Guest-flow planning", "Coordinator assignment"],
    customisation: "Traditional or formal dress code, language preference, ladies' assistance on request.",
  },
  {
    id: "corporate-launches",
    icon: "briefcase",
    title: "Corporate Events & Brand Launches",
    short: "Polished access control and protocol support for conferences, launches and leadership summits.",
    suitable: ["Product launches", "Conferences & summits", "Dealer meets", "Press events"],
    scope: "Registration and entry management, stage and green-room access control, media area coordination and VIP seating support.",
    planning: ["Agenda review", "Access-zone mapping", "Credential flow planning", "On-site coordination desk"],
    customisation: "Formal business attire, badge-check support, multilingual guest assistance.",
  },
  {
    id: "concert-security",
    icon: "music",
    title: "Concert & Live Event Security",
    short: "High-energy events handled with structure — entry flow, stage zones and artist movement.",
    suitable: ["Concerts", "Music festivals", "College fests", "Live shows"],
    scope: "Entry queue management, barricade and front-of-stage presence, backstage access control and artist movement coordination.",
    planning: ["Crowd estimate review", "Zone and barricade planning", "Entry-gate scheduling", "Exit flow coordination"],
    customisation: "Team scaling by expected footfall, overnight or multi-day deployments.",
  },
  {
    id: "crowd-access",
    icon: "users",
    title: "Crowd & Access Management",
    short: "Orderly queues, controlled entries and smooth guest flow at high-footfall occasions.",
    suitable: ["Public openings", "Exhibitions", "Seasonal sales", "Ticketed events"],
    scope: "Queue organisation, entry and exit lane management, capacity awareness at gates and courteous guest direction.",
    planning: ["Footfall assessment", "Gate and lane layout", "Signage coordination", "Peak-hour staffing"],
    customisation: "Barricade coordination, RSVP list checks, time-slot entry management.",
  },
  {
    id: "political-public",
    icon: "flag",
    title: "Political & Public Event Support",
    short: "Disciplined, respectful support for public meetings, rallies and community gatherings.",
    suitable: ["Public meetings", "Roadshows", "Community gatherings", "Felicitations"],
    scope: "Stage access control, leader movement support within the venue, crowd lane management and coordination with organisers.",
    planning: ["Programme flow review", "Venue and route assessment", "Zone deployment plan", "Organiser coordination"],
    customisation: "Deployment scale, visible or low-profile presence, multi-location support.",
  },
  {
    id: "hospitality-protocol",
    icon: "handshake",
    title: "Hospitality & Protocol Coordination",
    short: "A courteous front-of-house layer that welcomes guests while upholding event protocol.",
    suitable: ["Luxury weddings", "Galas & receptions", "Corporate hospitality", "Private soirées"],
    scope: "Guest welcome and guidance, seating assistance, protocol sequencing for dignitaries and coordination with hospitality staff.",
    planning: ["Guest list and protocol review", "Welcome-flow design", "Staff coordination briefing", "On-floor supervision"],
    customisation: "Dress code alignment, language preference, seniority-aware protocol handling.",
  },
  {
    id: "backstage-control",
    icon: "lock",
    title: "Backstage & Restricted-Area Control",
    short: "Calm, consistent control of stage wings, green rooms and service corridors.",
    suitable: ["Concerts", "Fashion shows", "Award nights", "Television recordings"],
    scope: "Access-point staffing, credential checks, artist and crew corridor management and restricted-zone discipline.",
    planning: ["Zone classification", "Credential system setup", "Shift rotation planning", "Escalation protocol"],
    customisation: "Access-list formats, wristband or badge systems, overnight coverage.",
  },
  {
    id: "venue-parking",
    icon: "car",
    title: "Venue Entry, Exit & Parking Coordination",
    short: "First impressions and last memories — smooth vehicle flow and graceful arrivals.",
    suitable: ["Weddings", "Showroom launches", "Hotel events", "Large receptions"],
    scope: "Vehicle arrival sequencing, valet coordination support, VIP lane management and departure flow at closure.",
    planning: ["Driveway and gate review", "Peak arrival estimation", "Valet team coordination", "Signage and lighting check"],
    customisation: "VIP lane protocols, shuttle coordination, late-night departure support.",
  },
];

export const PILLARS = [
  {
    num: "I",
    title: "Discreet Presence",
    text: "Teams that blend with the event's dress code and atmosphere — alert, composed and never intrusive.",
  },
  {
    num: "II",
    title: "Structured Coordination",
    text: "Clear deployment zones, defined reporting lines and venue-specific planning before the first guest arrives.",
  },
  {
    num: "III",
    title: "Guest-First Approach",
    text: "Polite access control and professional interaction — hospitality in tone, discipline in practice.",
  },
];

export const STEPS = [
  { num: "01", title: "Confidential Consultation", text: "We begin by understanding your event, venue, guest profile and service requirements — privately and without obligation." },
  { num: "02", title: "Event Assessment", text: "Our team reviews access points, movement areas, sensitive zones and expected crowd behaviour." },
  { num: "03", title: "Deployment Plan", text: "You receive a considered recommendation covering team size, reporting structure and positioning." },
  { num: "04", title: "On-Site Coordination", text: "On the day, we manage arrival, access, guest flow and every assigned security zone with a dedicated coordinator." },
  { num: "05", title: "Event Closure", text: "We coordinate safe exit movement and conclude the deployment as professionally as it began." },
];

export const HOSPITALITY_POINTS = [
  "VIP and guest arrival assistance",
  "Queue and entrance management",
  "Guest guidance and wayfinding",
  "Stage and backstage access control",
  "Family and organiser coordination",
  "Vendor and service-entry control",
  "Vehicle arrival and departure flow",
  "Professional communication with venue staff",
];

export const WHY_US = [
  { icon: "sparkles", title: "Smartly Groomed Event Teams", text: "Tailored, presentable and trained for premium environments." },
  { icon: "clipboard", title: "Event-Specific Deployment Planning", text: "Every event receives its own assessment and positioning plan." },
  { icon: "smile", title: "Professional & Courteous Presence", text: "Firm where needed, gracious everywhere else." },
  { icon: "scale", title: "Flexible Team Strength", text: "From a two-person detail to full-venue deployments." },
  { icon: "user", title: "Dedicated Event Coordinator", text: "One point of contact from consultation to closure." },
  { icon: "map", title: "Multi-City Service Capability", text: "Serving events across Andhra Pradesh and Telangana." },
  { icon: "phone", title: "Fast Call & WhatsApp Response", text: "Reach the coordination team directly, any day." },
  { icon: "shield", title: "Privacy-Conscious Handling", text: "Guest lists, movements and event details stay private." },
];

export const LOCATIONS = [
  { city: "Vijayawada", note: "Head office and primary coordination hub", primary: true },
  { city: "Guntur", note: "Weddings, public events and showroom launches" },
  { city: "Amaravati", note: "Government-adjacent and institutional events" },
  { city: "Hyderabad", note: "Corporate launches, concerts and celebrity appearances" },
  { city: "Visakhapatnam", note: "Beachfront venues, weddings and corporate gatherings" },
  { city: "Tirupati", note: "Temple-town events, weddings and public functions" },
];

export const SHOWCASE = [
  {
    id: "sc-wedding",
    category: "Premium Weddings",
    title: "A Grand Telugu Wedding Reception",
    city: "Vijayawada",
    desc: "Guest reception, stage-area attention and parking coordination for a large family celebration.",
    services: ["Wedding Security", "Guest Management", "Parking Coordination"],
    img: img("1583939003579-730e3918a45a", 1400),
    alt: "Indian wedding couple in traditional attire during a ceremony",
  },
  {
    id: "sc-celebrity",
    category: "Celebrity Appearances",
    title: "Film Promotion Appearance",
    city: "Hyderabad",
    desc: "Arrival support, crowd lane management and stage access control for a promotional visit.",
    services: ["VIP Movement Support", "Crowd Management"],
    img: img("1547786106-2588961a32f6", 1400),
    alt: "Red carpet and stanchions prepared for a celebrity arrival",
  },
  {
    id: "sc-corporate",
    category: "Corporate Events",
    title: "Regional Leadership Summit",
    city: "Hyderabad",
    desc: "Registration flow, credential checks and green-room access for a two-day corporate summit.",
    services: ["Corporate Event Support", "Access Control"],
    img: img("1540575467063-178a50c2df87", 1400),
    alt: "Audience seated at a professional corporate conference",
  },
  {
    id: "sc-concert",
    category: "Concerts",
    title: "Live Music Evening",
    city: "Visakhapatnam",
    desc: "Entry queue management, front-of-stage presence and backstage control for a live performance.",
    services: ["Concert Security", "Backstage Control"],
    img: img("1501281668745-f7f57925c3b4", 1400),
    alt: "Audience enjoying a live concert under stage lights",
  },
  {
    id: "sc-showroom",
    category: "Showroom & Brand Launches",
    title: "Flagship Showroom Opening",
    city: "Guntur",
    desc: "Opening-day crowd flow, VIP lane and parking coordination for a retail launch.",
    services: ["Crowd Management", "Entry & Parking"],
    img: img("1441986300917-64674bd600d8", 1400),
    alt: "Interior of a premium retail showroom at opening",
  },
  {
    id: "sc-political",
    category: "Political & Public Gatherings",
    title: "Public Felicitation Meeting",
    city: "Amaravati",
    desc: "Stage access control and movement support for a large public gathering.",
    services: ["Public Event Support", "Stage Access Control"],
    img: img("1529107386315-e1a2ed48a620", 1400),
    alt: "Large crowd gathered at an outdoor public event",
  },
  {
    id: "sc-private",
    category: "Private VIP Celebrations",
    title: "Private Anniversary Soirée",
    city: "Hyderabad",
    desc: "Discreet perimeter presence and guest-list entry for an invitation-only evening.",
    services: ["Private Event Security", "Protocol Coordination"],
    img: img("1464366400600-7168b8af9bc3", 1400),
    alt: "Elegant candlelit dinner arrangement at a private celebration",
  },
];

export const FAQS = [
  {
    q: "How early should event security be booked?",
    a: "We recommend reaching out at least one to two weeks before your event so we can complete a proper assessment. Larger concerts, celebrity visits and multi-day weddings benefit from earlier conversations. For urgent requirements, call us — we will always tell you honestly what is feasible.",
  },
  {
    q: "How is the required team size decided?",
    a: "Team size depends on the venue layout, number of entry and exit points, expected guest count, guest profile and the nature of the programme. After a short consultation and, where useful, a venue visit, we recommend a strength that fits the occasion — no more, no less.",
  },
  {
    q: "Can the team follow a wedding or corporate dress code?",
    a: "Yes. Our standard is a tailored black suit; for weddings and themed occasions we can align with a specified dress code so the team blends naturally with the atmosphere.",
  },
  {
    q: "Do you provide services outside Vijayawada?",
    a: "Yes. We serve events across Andhra Pradesh and Telangana, including Guntur, Amaravati, Hyderabad, Visakhapatnam and Tirupati. Other locations can be arranged on request.",
  },
  {
    q: "Can you support celebrity arrival and backstage movement?",
    a: "Yes. We regularly plan arrival-to-departure movement, holding areas and backstage access for public figures. We coordinate quietly with organisers, venue teams and travel managers so the visit feels effortless.",
  },
  {
    q: "Is an event assessment available before deployment?",
    a: "Yes. An assessment of access points, movement areas and sensitive zones is part of our standard planning process and is completed before we confirm a deployment plan.",
  },
  {
    q: "Can organisers request a dedicated coordinator?",
    a: "Yes. Every confirmed deployment can include a single point of coordination who handles briefing, positioning and on-day communication with your organising team.",
  },
  {
    q: "How can I receive a quotation?",
    a: "Share your event details through the enquiry form, or simply call or WhatsApp us. After understanding your requirements, we provide a clear, customised quotation with no obligation.",
  },
];

export const SAMPLE_NOTE =
  "Sample showcase entry — representative imagery and descriptions shown for illustration. Real client events are published only with written permission.";
